module.exports = __webpack_public_path__ + "media/images/application/template/minus-grey-b201ac763cd6c93ae2447e0961084bf9.svg";